export default "__VITE_ASSET__CiXm3Wzc__"